import React from 'react';
import { Box } from '@mui/material';
import familiplusPtsIcn from '../../../images/Familiplus pts Icn.svg';

const FamiliplusPointBox = (prop: { points: string }): JSX.Element => {
  return (
    <>
      <Box display="inherit" marginLeft="8px">
        <Box className="boxFpPts">
          <Box>+</Box>
          <Box fontSize=".75rem">{prop.points} pts</Box>
          <Box component="img" src={familiplusPtsIcn} width="1rem" height="1rem" alt=""></Box>
        </Box>
      </Box>
    </>
  );
};

export default FamiliplusPointBox;
